import BaseRepository from '@/api/repositories/BaseRepository';

export default class AuthRepository extends BaseRepository {
	me() {
		return this.get('me', {});
	}

	login(data) {
		return this.post('login', {}, data);
	}

	logout() {
		return this.post('logout', {}, {});
	}

	changeForgotPassword(data, type = null) {
		const params = type ? { type } : {};
		return this.post('changePassword', params, data);
	}
}
